import React from "react";

const Input: React.FC<{
  name: string;
  label: string;
  value?: string;
  status?: string;
  defaultChecked?: boolean;
  onChange?: any;
}> = (props) => {
  return (
    <div className={`select-container ${props.status}`}>
      <label className="checkbox__container" htmlFor={props.value}>
        <input
          name={props.name}
          id={props.value}
          type="radio"
          value={props.value}
          defaultChecked={props.defaultChecked}
          onChange={props.onChange}
        />
        <span className="checkmark"></span>
        {props.label}
      </label>
    </div>
  );
};

export default Input;
